<script>
import anychart from 'anychart'
import { insightsStatusColors } from '@utils/design/status-css-classes'

export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },

    chartData: {
      type: Array,
      default: () => [],
    },

    seriesMap: {
      type: Array,
      default: () => [],
    },

    chartType: {
      type: String,
      default: () => 'column',
    },
  },

  data() {
    return {
      chart: null,
      dataSet: null,
    }
  },

  watch: {
    chartData() {
      // set our data to data set
      this.dataSet.data(this.chartData)
    },
  },

  mounted() {
    anychart.licenseKey('openindustry.org-312f7279-c0b595db')
    // eslint-disable-next-line new-cap
    this.chart = new anychart.fromJson(this.options)
    var credits = this.chart.credits()
    credits.enabled(false)

    // set the default style
    this.chart.background().fill('#1a1a1a')
    this.chart.container(this.$el).draw()

    this.chart.palette(anychart.palettes.v6)
    // this.chart.legend().enabled(true)

    // create data set on our data
    this.dataSet = anychart.data.set()
    // set our data to data set
    this.dataSet.data(this.chartData)

    // map data for the each series
    this.seriesMap.forEach((map) => {
      let mapping = this.dataSet.mapAs(map)
      let series = this.chart[this.chartType](mapping)

      // set the default style
      series.normal().stroke('#cccccc', 2)
      series.hovered().stroke('#d4d4d4', 2)
      series.selected().stroke('#cccccc', 4)

      // set custom coloring
      series.fill(coloringFunction)

      series.name(map.name)
    })

    // custom coloring function
    function coloringFunction() {
      // get the default otherwise
      return insightsStatusColors(this.series.name())
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    method() {},
  },
}
</script>

<template>
  <div class="chart"></div>
</template>
